export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST"
export const RESET_PASSWORD_END_PROCESS = "RESET_PASSWORD_END_PROCESS"
